import type { ChartsItemContentProps } from '@mui/x-charts/ChartsTooltip';
import type { DefaultizedPieValueType } from '@mui/x-charts/models';
import { useEffect } from 'react';

type PieChartHoverWrapperProps = {
  render: (itemData: DefaultizedPieValueType) => React.ReactNode
  onChartHover?: (itemData: DefaultizedPieValueType) => void
  pieChartHoverProps: ChartsItemContentProps<'pie'>
};

export const PieChartHoverWrapper: React.FC<PieChartHoverWrapperProps> = ({ render, onChartHover, pieChartHoverProps }) => {
  const { itemData, series } = pieChartHoverProps;
  const hoveredItemData = series.data[itemData.dataIndex];
  
  useEffect(() => onChartHover?.(hoveredItemData), [hoveredItemData, onChartHover]);

  return <>{render(hoveredItemData)}</>;
};